import { DtLookup } from '@ow/ditto-core'

const { transformer } = DtLookup
export { transformer }
